// index.js Authorizer from '@emcd-shared/auth-service/pages/Authorizer.vue'
import {
  ROUTES,
  API_AND_INTEGRATION_ROUTE_KEY,
  EARN_ON_SWAP_ROUTE_KEY,
  PAYMENT_LINKS_ROUTES,
  MASS_PAYMENTS_ROUTES,
  INVOICES_ROUTES,
  PROFILE_ROUTES,
} from '@/shared/constants/routes'

import CreatePaymentLinkButton from '@/shared/ui/CreatePaymentLinkButton/CreatePaymentLinkButton.vue'
import CreateApiKeyButton from '@/shared/ui/CreateApiKeyButton/CreateApiKeyButton.vue'
import CreateWidgetButton from '@/shared/ui/CreateWidgetButton/CreateWidgetButton.vue'
import CreateMassPaymentButton from '@/shared/ui/CreateMassPaymentButton/CreateMassPaymentButton.vue'
import CreateInvoiceButton from '@/shared/ui/CreateInvoiceButton/CreateInvoiceButton.vue'
import LogoutButton from '@/shared/ui/LogoutButton/LogoutButton.vue'

export default [
  { path: '/', redirect: ROUTES.PAYMENT_LINKS.ROOT },
  {
    path: ROUTES.PAYMENT_LINKS.ROOT,
    name: 'Index',
    redirect: ROUTES.PAYMENT_LINKS.START,
    meta: {
      requiresAuth: true,
      layout: 'main',
      links: 'paymentLinks',
      headerContent: {
        component: CreatePaymentLinkButton,
      },
    },
    children: [
      {
        path: ROUTES.PAYMENT_LINKS.START,
        name: PAYMENT_LINKS_ROUTES.START,
        meta: {
          title: 'routes["PaymentLinks | Start"]',
        },

        component: () =>
          import(
            /* webpackChunkName: "payment-links-start" */ '@/pages/payment-links/start/index.vue'
          ),
      },
      {
        path: ROUTES.PAYMENT_LINKS.LIST,
        name: PAYMENT_LINKS_ROUTES.LIST,
        meta: { title: 'routes["PaymentLinks | List"]' },
        component: () =>
          import(
            /* webpackChunkName: "payment-links-list" */ '@/pages/payment-links/list/index.vue'
          ),
      },
      {
        path: ROUTES.PAYMENT_LINKS.HISTORY,
        name: PAYMENT_LINKS_ROUTES.HISTORY,
        meta: { title: 'routes["PaymentLinks | History"]' },
        component: () =>
          import(
            /* webpackChunkName: "payment-links-history" */ '@/pages/payment-links/history/index.vue'
          ),
      },
      {
        path: ROUTES.PAYMENT_LINKS.DETAIL,
        name: PAYMENT_LINKS_ROUTES.DETAIL,
        meta: { title: 'routes["PaymentLinks | Details"]' },
        component: () =>
          import(
            /* webpackChunkName: "payment-links-detail" */ '@/pages/payment-links/detail/index.vue'
          ),
      },
      // {
      //   path: ROUTES.PAYMENT_LINKS.SETTINGS,
      //   name: PAYMENT_LINKS_ROUTES.SETTINGS,
      //   meta: { title: 'routes["PaymentLinks | Settings"]' },
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "payment-links-settings" */ '@/pages/payment-links/settings/index.vue'
      //     ),
      // },
    ],
  },

  {
    path: ROUTES.API_AND_INTEGRATION.ROOT,
    name: 'api-and-integration',
    redirect: {
      name: API_AND_INTEGRATION_ROUTE_KEY.START,
    },
    meta: {
      requiresAuth: true,
      layout: 'main',
      links: 'apiAndIntegrationsLinks',
      headerContent: {
        component: CreateApiKeyButton,
      },
    },
    children: [
      {
        path: ROUTES.API_AND_INTEGRATION.START,
        name: API_AND_INTEGRATION_ROUTE_KEY.START,
        meta: {
          title: 'routes["API | Start"]',
        },

        component: () =>
          import(
            /* webpackChunkName: "earn-on-swap-start" */ '@/pages/api-and-integration/start/index.vue'
          ),
      },
      {
        path: ROUTES.API_AND_INTEGRATION.LIST,
        name: API_AND_INTEGRATION_ROUTE_KEY.LIST,
        meta: { title: 'routes["API | List"]' },
        component: () =>
          import(
            /* webpackChunkName: "earn-on-swap-start" */ '@/pages/api-and-integration/list/index.vue'
          ),
      },
      // {
      //   path: ROUTES.API_AND_INTEGRATION.SETTINGS,
      //   name: API_AND_INTEGRATION_ROUTE_KEY.SETTINGS,
      //   meta: { title: 'routes["API | Settings"]' },
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "earn-on-swap-start" */ '@/pages/api-and-integration/settings/index.vue'
      //     ),
      // },
    ],
  },

  {
    path: ROUTES.EARN_ON_SWAP.ROOT,
    name: 'earn-on-swap',
    redirect: ROUTES.EARN_ON_SWAP.START,
    meta: {
      requiresAuth: true,
      layout: 'main',
      links: 'earnOnSwapLinks',
      headerContent: {
        component: CreateWidgetButton,
      },
    },
    children: [
      {
        path: ROUTES.EARN_ON_SWAP.START,
        name: EARN_ON_SWAP_ROUTE_KEY.START,
        meta: {
          title: 'routes["EarnOnSwap | Start"]',
        },

        component: () =>
          import(
            /* webpackChunkName: "earn-on-swap-start" */ '@/pages/earn-on-swap/index.vue'
          ),
      },
      {
        path: ROUTES.EARN_ON_SWAP.LIST,
        name: EARN_ON_SWAP_ROUTE_KEY.LIST,
        meta: { title: 'routes["EarnOnSwap | Links"]' },
        component: () =>
          import(
            /* webpackChunkName: "earn-on-swap-links" */ '@/pages/earn-on-swap/links/index.vue'
          ),
      },
      // {
      //   path: ROUTES.EARN_ON_SWAP.SETTINGS,
      //   name: EARN_ON_SWAP_ROUTE_KEY.SETTINGS,
      //   meta: { title: 'routes["EarnOnSwap | Settings"]' },
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "earn-on-swap-settings" */ '@/pages/earn-on-swap/settings/index.vue'
      //     ),
      // },
      {
        path: ROUTES.EARN_ON_SWAP.WIDGET_DETAILS,
        name: EARN_ON_SWAP_ROUTE_KEY.WIDGET,
        meta: { title: 'routes["EarnOnSwap | WidgetDetails"]' },
        component: () =>
          import(
            /* webpackChunkName: "earn-on-swap-widget-details" */ '@/pages/earn-on-swap/widget-details/ui/WidgetDetailsPage.vue'
          ),
      },
    ],
  },

  {
    path: ROUTES.MASS_PAYMENTS.ROOT,
    name: 'MassPayments',
    redirect: ROUTES.MASS_PAYMENTS.START,
    meta: {
      requiresAuth: true,
      layout: 'main',
      links: 'massPaymentsLinks',
      headerContent: {
        component: CreateMassPaymentButton,
      },
    },
    children: [
      {
        path: ROUTES.MASS_PAYMENTS.START,
        name: MASS_PAYMENTS_ROUTES.START,
        meta: {
          title: 'routes["MassPayments | Start"]',
        },

        component: () =>
          import(
            /* webpackChunkName: "payment-links-start" */ '@/pages/mass-payments/start/index.vue'
          ),
      },
      {
        path: ROUTES.MASS_PAYMENTS.LIST,
        name: MASS_PAYMENTS_ROUTES.LIST,
        meta: { title: 'routes["MassPayments | List"]' },
        component: () =>
          import(
            /* webpackChunkName: "payment-links-list" */ '@/pages/mass-payments/list/index.vue'
          ),
      },
      {
        path: ROUTES.MASS_PAYMENTS.HISTORY,
        name: MASS_PAYMENTS_ROUTES.HISTORY,
        meta: { title: 'routes["MassPayments | History"]' },
        component: () =>
          import(
            /* webpackChunkName: "mass-payments-history" */ '@/pages/mass-payments/history/index.vue'
          ),
      },
      {
        path: ROUTES.MASS_PAYMENTS.RECIPIENTS,
        name: MASS_PAYMENTS_ROUTES.RECIPIENTS,
        meta: {
          title: 'routes["MassPayments | Recipients"]',
          headerContent: {
            component: CreateMassPaymentButton,
          },
        },
        component: () =>
          import(
            /* webpackChunkName: "mass-payments-recipients" */ '@/pages/mass-payments/recipients/index.vue'
          ),
      },
      {
        path: ROUTES.MASS_PAYMENTS.DETAIL,
        name: MASS_PAYMENTS_ROUTES.DETAIL,
        meta: { title: 'routes["MassPayments | Details"]' },
        component: () =>
          import(
            /* webpackChunkName: "payment-links-detail" */ '@/pages/mass-payments/detail/index.vue'
          ),
      },
      // {
      //   path: ROUTES.PAYMENT_LINKS.SETTINGS,
      //   name: PAYMENT_LINKS_ROUTES.SETTINGS,
      //   meta: { title: 'routes["PaymentLinks | Settings"]' },
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "payment-links-settings" */ '@/pages/payment-links/settings/index.vue'
      //     ),
      // },
    ],
  },

  {
    path: ROUTES.INVOICES.ROOT,
    name: 'invoices',
    redirect: ROUTES.INVOICES.START,
    meta: {
      requiresAuth: true,
      layout: 'main',
      links: 'invoicesLinks',
      headerContent: {
        component: CreateInvoiceButton,
      },
    },
    children: [
      {
        path: ROUTES.INVOICES.START,
        name: INVOICES_ROUTES.START,
        meta: {
          title: 'routes["Invoices | Start"]',
        },

        component: () =>
          import(
            /* webpackChunkName: "invoices-start" */ '@/pages/invoices/start/index.vue'
          ),
      },
      {
        path: ROUTES.INVOICES.LIST,
        name: INVOICES_ROUTES.LIST,
        meta: { title: 'routes["Invoices | List"]' },
        component: () =>
          import(
            /* webpackChunkName: "invoices-list" */ '@/pages/invoices/list/index.vue'
          ),
      },
      {
        path: ROUTES.INVOICES.DETAIL,
        name: INVOICES_ROUTES.DETAIL,
        meta: { title: 'routes["Invoices | Details"]' },
        component: () =>
          import(
            /* webpackChunkName: "invoices-detail" */ '@/pages/invoices/detail/index.vue'
          ),
      },
      // {
      //   path: ROUTES.INVOICES.SETTINGS,
      //   name: INVOICES_ROUTES.SETTINGS,
      //   meta: { title: 'routes["Invoices | Settings"]' },
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "invoices-settings" */ '@/pages/invoices/settings/index.vue'
      //     ),
      // },
    ],
  },
  // Wallet
  {
    path: ROUTES.WALLET.ROOT,
    name: 'wallet',
    redirect: ROUTES.WALLET.MAIN,
    meta: {
      requiresAuth: true,
      layout: 'main',
      links: 'walletLinks',
    },
    children: [
      {
        path: ROUTES.WALLET.MAIN,
        name: 'wallet-main',
        meta: { title: 'routes["Wallet | Main"]' },
        component: () =>
          import(/* webpackChunkName: "wallet" */ '@/pages/wallet/index.vue'),
      },
      {
        path: ROUTES.WALLET.HISTORY,
        name: 'wallet-history',
        meta: { title: 'routes["Wallet | History"]' },
        component: () =>
          import(
            /* webpackChunkName: "wallet-history" */ '@/pages/wallet/history/index.vue'
          ),
      },
      {
        path: ROUTES.WALLET.MERCURYO_KYC_MOCK,
        name: 'wallet-mercuryo-kyc-mock',
        meta: {
          layout: 'system',
          title: 'routes["Wallet | Mercuryo KYC Mock"]',
        },
        component: () =>
          import(
            /* webpackChunkName: "wallet-mercuryo-kyc-mock" */ '@/pages/wallet/MercuryoKyc/MercuryoKycMock.vue'
          ),
      },
      {
        path: ROUTES.WALLET.MERCURYO_KYC_RESULT,
        name: 'wallet-mercuryo-kyc-result',
        meta: {
          layout: 'system',
          title: 'routes["Wallet | Mercuryo KYC Result"]',
        },
        component: () =>
          import(
            /* webpackChunkName: "wallet-mercuryo-kyc-result" */ '@/pages/wallet/MercuryoKyc/MercuryoKycResult.vue'
          ),
      },
      {
        path: ROUTES.WALLET.MERCURYO_SELL_RESULT,
        name: 'wallet-mercuryo-sell-result',
        meta: {
          layout: 'system',
          title: 'routes["Wallet | Mercuryo Sell Result"]',
        },
        component: () =>
          import(
            /* webpackChunkName: "wallet-mercuryo-sell-result" */ '@/pages/wallet/MercuryoKyc/MercuryoSellResult.vue'
          ),
      },
    ],
  },

  // Profile
  {
    path: ROUTES.PROFILE.ROOT,
    name: 'profile',
    redirect: ROUTES.PROFILE.SECURITY,
    meta: {
      requiresAuth: true,
      layout: 'main',
      links: 'profileLinks',
      headerContent: {
        component: LogoutButton,
      },
    },
    children: [
      {
        path: ROUTES.PROFILE.ACCOUNT_CENTER,
        name: PROFILE_ROUTES.ACCOUNT_CENTER,
        meta: { title: 'routes["Profile | AccountCenter"]' },
        component: () =>
          import(
            /* webpackChunkName: "profile-account-center" */ '@/pages/profile/account-center/index.vue'
          ),
      },
      {
        path: ROUTES.PROFILE.SECURITY,
        name: PROFILE_ROUTES.SECURITY,
        meta: { title: 'routes["Profile | Security"]' },
        component: () =>
          import(
            /* webpackChunkName: "profile-security" */ '@/pages/profile/security/index.vue'
          ),
      },
      {
        path: ROUTES.PROFILE.PREFERENCES,
        name: PROFILE_ROUTES.PREFERENCES,
        meta: { title: 'routes["Profile | Preferences"]' },
        component: () =>
          import(
            /* webpackChunkName: "profile-preferences" */ '@/pages/profile/preferences/index.vue'
          ),
      },
    ],
  },

  // System
  { path: ROUTES.AUTH.ROOT, redirect: ROUTES.AUTH.LOGIN },
  {
    path: ROUTES.AUTH.LOGIN,
    name: 'Login',
    component: () =>
      import(/* webpackChunkName: "Login" */ '@/pages/auth/login/index.vue'),
    meta: {
      requiresAuth: false,
      layout: 'auth',
      title: 'routes["Auth | Login"]',
    },
  },
  {
    path: ROUTES.AUTH.REGISTRATION,
    name: 'Registration',
    component: () =>
      import(
        /* webpackChunkName: "Registration" */ '@/pages/auth/registration/index.vue'
      ),
    meta: {
      requiresAuth: false,
      layout: 'auth',
      title: 'routes["Auth | Registration"]',
    },
  },
  // Страница успеха / подтверждения почты после регистрации и перехода по ссылке из письма
  {
    path: ROUTES.AUTH.TELEGRAM_REGISTRATION,
    name: 'RegistrationTelegram',
    component: () =>
      import(
        /* webpackChunkName: "Registration" */ '@/pages/auth/registration/telegram/index.vue'
      ),
    meta: {
      requiresAuth: false,
      layout: 'auth',
      title: 'routes["Auth | TelegramRegistration"]',
    },
  },
  {
    path: ROUTES.AUTH.VERIFY_EMAIL,
    name: 'RegistrationConfirm',
    component: () =>
      import(
        /* webpackChunkName: "RegistrationConfirm" */ '@/pages/auth/verify-email/index.vue'
      ),
    props: true,
    meta: {
      requiresAuth: false,
      layout: 'auth',
      title: 'routes["Auth | VerifyEmail"]',
    },
  },
  // Запрос (форма) на восстановление пароля
  {
    path: ROUTES.AUTH.RESTORE,
    name: 'Restore',
    component: () =>
      import(
        /* webpackChunkName: "RestorePassword" */ '@/pages/auth/restore/index.vue'
      ),
    meta: {
      requiresAuth: false,
      layout: 'auth',
      title: 'routes["Auth | Restore"]',
    },
  },
  // Форма ввода нового пароля по восстановлению после перехода по ссылке из письма
  {
    path: ROUTES.AUTH.RESTORE_PASSWORD,
    name: 'NewPassword',
    component: () =>
      import(
        /* webpackChunkName: "NewPassword" */ '@/pages/auth/restore-passwd/index.vue'
      ),
    props: true,
    meta: {
      requiresAuth: false,
      layout: 'auth',
      title: 'routes["Auth | NewPassword"]',
    },
  },
  // Suspended. Заглушка когда аккаунт заблокирован
  {
    path: ROUTES.AUTH.SUSPENDED,
    name: 'Suspended',
    component: () =>
      import(
        /* webpackChunkName: "Suspended" */ '@/pages/auth/suspended/index.vue'
      ),
    meta: {
      requiresAuth: false,
      layout: 'system',
      title: 'routes["Auth | Suspended"]',
    },
  },
  {
    path: ROUTES.AUTH.AUTHORIZER,
    name: 'Authorizer',
    component: () =>
      import(
        /* webpackChunkName: "LocalAuthorizer" */ '@/pages/auth/local-authorizer/index.vue'
      ),
    meta: {
      requiresAuth: false,
      layout: 'system',
      title: 'routes["Auth | Authorizer"]',
    },
  },
  // Confirm pages (email confirmation links)
  {
    path: ROUTES.CONFIRM.PHONE,
    name: 'confirm-phone',
    component: () =>
      import(
        /* webpackChunkName: "confirm-phone" */ '@/pages/confirm/phone/index.vue'
      ),
    meta: {
      requiresAuth: false,
      layout: 'global',
      title: 'routes["Confirm | Phone"]',
    },
  },
  {
    path: ROUTES.CONFIRM.GOOGLE,
    name: 'confirm-google',
    component: () =>
      import(
        /* webpackChunkName: "confirm-google" */ '@/pages/confirm/google/index.vue'
      ),
    meta: {
      requiresAuth: false,
      layout: 'global',
      title: 'routes["Confirm | Google"]',
    },
  },
  {
    path: ROUTES.CONFIRM.PASSWORD_CHANGE,
    name: 'confirm-password-change',
    component: () =>
      import(
        /* webpackChunkName: "confirm-password-change" */ '@/pages/confirm/password/change/index.vue'
      ),
    meta: {
      requiresAuth: false,
      layout: 'global',
      title: 'routes["Confirm | PasswordChange"]',
    },
  },
  {
    path: ROUTES.CONFIRM.PHONE_DELETE,
    name: 'confirm-phone-delete',
    component: () =>
      import(
        /* webpackChunkName: "confirm-phone-delete" */ '@/pages/confirm/phone/delete/index.vue'
      ),
    meta: {
      requiresAuth: false,
      layout: 'global',
      title: 'routes["Confirm | PhoneDelete"]',
    },
  },

  {
    path: '/:pathMatch(.*)*',
    redirect: '/404',
  },
  {
    path: '/404',
    name: '404',
    component: () =>
      import(
        /* webpackChunkName: "Error404Page" */ '@/pages/not-found/index.vue'
      ),
    meta: {
      requiresAuth: false,
      layout: 'system',
      title: 'routes["System | 404"]',
    },
  },
]
